<template>
  <div class="schedule">
    <div class="con">
      <div class="xin">
        <img :src="user.avatar" alt="" />
        <span>{{ user.nickname }}</span>
      </div>
      <div class="jin">
        <el-steps :active="status" align-center finish-status="success">
          <el-step title="待受理"></el-step>
          <el-step title="已受理"></el-step>
          <el-step title="修理中"></el-step>
          <el-step title="修理完毕"></el-step>
        </el-steps>
      </div>
      <div class="pai">
        <span class="title">拍照图片</span>
        <div class="imgBoxs">
          <div class="imgbox">
            <img v-for="(item, index) in uploadPictures" :key="index" :src="item" alt="" />
          </div>
          <VueCoreImageUpload class="btn btn-primary" :crop="false" compress="80" @imageuploaded="imageuploaded"
            :headers="headers" :max-file-size="5242880" :credentials="false" inputAccept="image/*" inputOfFile="file"
            :url="url" v-if="uploadPictures.length < 8">
            <div class="pictrue uploadBnt acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
      <div class="jie">
        <span>维修结果</span>
        <el-select v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="jie" v-if="value == '未修好'">
        <span>未维修的原因</span>
        <input type="text" v-model='repair_msg'>
      </div>
    </div>
    <div class="ti">
      <button @click="schedule">立即提交</button>
    </div>
  </div>
</template>

<script>
import { postOrderProduct, postOrderComment } from "@api/store";
import { scheduleApi } from "@api/login";
import { getUserInfo } from "@api/user";
import { trim, VUE_APP_API_URL } from "@utils";
import { required } from "@utils/validate";
import VueCoreImageUpload from "vue-core-image-upload";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
  components: {
    VueCoreImageUpload,
  },
  data() {
    return {
      user: {},
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      select: "",
      user: {},
      status: this.$route.query.status * 1 + 1,
      orderCon: {
        cartProduct: {
          productInfo: {},
        },
      },
      scoreList: [
        {
          name: "商品质量",
          stars: ["", "", "", "", ""],
          index: -1,
        },
        {
          name: "服务态度",
          stars: ["", "", "", "", ""],
          index: -1,
        },
      ],
      url: `http://www.bjdgyjd.com/api/upload/image`,

      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token,
      },
      uploadPictures: [],
      expect: "",
      unique: this.$route.params.id,
      options: [
        {
          value: "未修好",
          label: "未修好",
        },
        {
          value: "已修好",
          label: "已修好",
        },
      ],
      value: "",
      repair_msg: ''
    };
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.uploadPictures.push(res.data.url);
      console.log(this.uploadPictures);
    },
    schedule() {
      let status = this.value === "未修好" ? "2" : "3";
      let data = {
        id: this.$route.query.id,
        status,
        repair_images: this.uploadPictures.join(","),
        repair_msg: status == 2 ? this.repair_msg : ''
      };
      scheduleApi(data)
        .then((res) => {
          console.log(res);
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
          console.log(err);
        });
    },
  },
  mounted() {
    getUserInfo().then((res) => {
      this.user = res.data;
    });
    console.log(this.status);
    console.log(this.$route.query);
    if (this.$route.query.type == 1) {
      this.options = [
        {
          value: "未修好",
          label: "未修好",
        },
        {
          value: "已修好",
          label: "已修好",
        },
      ];
    } else {
      this.options = [
        {
          value: "未保洁",
          label: "未保洁",
        },
        {
          value: "已保洁",
          label: "已保洁",
        },
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  background-color: rgb(245, 245, 245);
  box-sizing: border-box;
  padding: 0.2rem;

  .con {
    box-sizing: border-box;
    padding: 0.2rem;
    background-color: white;

    .pictrue.uploadBnt {
      padding: 13px 7px;
      border: 0.02rem solid #ddd;

      div {
        color: #ccc;
      }
    }

    .xin {
      display: flex;
      align-items: center;
      padding-bottom: 0.1rem;
      border: 0.02rem solid #f5f5f5;
      margin-bottom: 0.2rem;

      span {
        color: black;
      }
    }

    .jin {
      padding-bottom: 0.1rem;
      border: 0.02rem solid #f5f5f5;
    }

    img {
      width: 30px;
      border-radius: 50%;
      margin-right: 0.2rem;
    }

    .pai {
      display: flex;
      margin-top: 0.2rem;
      padding-bottom: 0.1rem;
      border-bottom: 0.02rem solid #f5f5f5;

      .title {
        display: inline-block;
        margin-right: 0.2rem;
      }

      .g-core-image-upload-btn {
        height: 61px;
        width: 61px;
        border: 1px solid #ccc;
        line-height: 61px;

        div {
          height: 61px;
          border: none;
        }
      }

      .schedule .con .pictrue.uploadBnt {
        height: 61px;
      }

      .imgBoxs {
        display: flex;

        img {
          width: 61px;
          height: 61px;
          margin-right: 10px;
          border-radius: 0;
        }
      }

      .el-upload .el-upload--picture-card {
        background-color: #fbfdff;
        border: 0.02rem dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 55px;
        height: 55px;
        cursor: pointer;
        line-height: 55px;
        vertical-align: top;
      }
    }

    .jie {
      margin-top: 10px;
      height: 30px;
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        margin-right: 10px;
      }
    }

    .wei {
      margin-top: 0.2rem;
      margin-bottom: 0.4rem;

      span {
        display: inline-block;
        margin-right: 0.2rem;
      }
    }
  }

  .ti {
    position: fixed;
    bottom: 0.2rem;
    width: calc(100vw - 0.4rem);

    button {
      width: 100%;
      height: 30px;
      background-color: red;
      color: white;
      border-radius: 15px;
      font-family: PingFang SC-常规体, PingFang SC;
    }
  }
}
</style>
